// storybook-ignore: renderar JSON-LD <script> (SEO) — ingen visuell yta. Avsiktligt utan story, räkna den inte som saknad.
import * as React from 'react';

interface Props {
    structuredData?: string;
}

export const StructuredData: React.FunctionComponent<Props> = ({structuredData}) => {

    if(structuredData === null) return null;

    return (
        <React.Fragment>
            {structuredData && <script type="application/ld+json">
                {structuredData}
            </script>}
        </React.Fragment>
    );
};
